import Backdrop from "@mui/material/Backdrop";
import Grow from "@mui/material/Grow";
import Modal from "@mui/material/Modal";
import makeStyles from '@mui/styles/makeStyles';
import {history} from "common/history";
import Feedback from "components/Feedback";
import {get} from "lodash";
import React from "react";

// The feedback card opens over the session rather than as a screen of its own,
// the same way the quiz and the group answers do.
const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  holder: {
    transformOrigin: 'center center',
    display: 'flex',
    justifyContent: 'center',
    outline: 'none',
    maxWidth: '100%',
  },
});

function SessionFeedback({location, submitSessionFeedback, isLearningHub}) {
  const classes = useStyles();
  const sessionId = get(location, 'state.sessionId');

  const close = () => history.push(isLearningHub ? '/learninghub' : '/mentorship');

  return (
    <Modal
      open
      onClose={close}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{timeout: 220}}
    >
      <Grow in timeout={{enter: 240, exit: 160}}>
        <div className={classes.holder}>
          <Feedback
            sessionId={sessionId}
            submitSessionFeedback={submitSessionFeedback}
            isLearningHub={isLearningHub}
          />
        </div>
      </Grow>
    </Modal>
  );
}

export default SessionFeedback;
